// extracted by mini-css-extract-plugin
export default {"unauthorized":"Unauthorized_unauthorized__2AWJi","login":"Unauthorized_login__c9+3w","register":"Unauthorized_register__C-sbt"};